// Close (audit §4b; job page round 2, Amir 26 Oct: "one close control, top right, no box"): the one ×
// that closes anything that opens over a page, in every layer (Popover, the side panel, a dialog) and
// on a page that opens over another (the job page, opened from the board). It sits in its holder's top
// right corner, 34 × 34 for the pointer, and draws only the glyph: no frame, no fill, no ring, at rest or
// on hover. Hover and press draw the glyph's strokes heavier; keyboard focus draws a bar under it. A
// layer draws its own (placement "corner"); a page's toolbar puts it last in its row ("inline").
// IconButton has no close glyph, so nothing else can draw a × with a box round it. Escape does the
// same as pressing it. Reads only --close-*.
import { Button as AriaButton } from 'react-aria-components';
import { Glyph } from '../Glyph/Glyph.tsx';
import './Close.css';

export interface CloseProps {
  onPress: () => void;
  /** What closes, for screen readers ("Close the filter"); "Close" by default. */
  label?: string;
  /** corner: in its layer's top-right corner (the layer draws it); inline: last in a toolbar's row. */
  placement?: 'corner' | 'inline';
}

export function Close({ onPress, label = 'Close', placement = 'corner' }: CloseProps) {
  return (
    <AriaButton className="fl-close" data-placement={placement} aria-label={label} onPress={onPress}>
      <Glyph name="close" className="fl-close__glyph" />
    </AriaButton>
  );
}
